import { render, staticRenderFns } from "./shopPage.vue?vue&type=template&id=30a7aa7c&scoped=true&"
import script from "./shopPage.vue?vue&type=script&lang=ts&"
export * from "./shopPage.vue?vue&type=script&lang=ts&"
import style0 from "./shopPage.vue?vue&type=style&index=0&id=30a7aa7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7aa7c",
  null
  
)

export default component.exports